module.exports = __webpack_public_path__ + "static/aboutContactBack-8b076e08475fc576782020aa8cd5b8ae.png";